import { cn, getClassNames } from '../../lib/css/className/className';
import { SkinColor, SkinRole } from '../../lib/skin/getColorSkin/generated/types';
import { getColorSkin } from '../../lib/skin/getColorSkin/getColorSkin';
import { getSizeSkin } from '../../lib/skin/getSizeSkin/getSizeSkin';
import { cls as baseCls } from '../ButtonBase/ButtonBase';

import { ButtonColor, ButtonSize } from './types';

import './Button.css';

export const cls = cn('Button');

export const skinMap: Record<ButtonColor, SkinColor | SkinRole> = {
    accent: 'accent',
    normal: 'gray-low-contrast',
    contrast: 'gray-neutral',
    contour: 'gray-transparent-contour',
    text: 'gray-transparent',
    'text-supplementary': 'gray-transparent',
    link: 'blue-transparent',
    ai: 'ai-high-contrast',
};

type cnButtonMods = {
    /** Цветовое оформление кнопки */
    color: ButtonColor;

    /** Размер кнопки */
    size?: ButtonSize;

    /** Признак наведения */
    hovered?: boolean;

    /** Признак фокуса */
    focused?: boolean;

    /** Признак иконки в качестве единственного содержимого */
    'has-only-icon'?: boolean;

    /** Признак отключения кнопки */
    disabled?: boolean;
};

export const cnButton = (mods: cnButtonMods) => {
    const buttonBaseCls = baseCls({ hovered: mods.hovered, focused: mods.focused, disabled: mods.disabled }, [
        getColorSkin(skinMap[mods.color], { isHovered: mods.hovered }),
    ]);

    const buttonCls = cls({ color: mods.color, size: mods.size, 'has-only-icon': mods['has-only-icon'] }, [
        mods.size && getSizeSkin(mods.size),
    ]);

    return getClassNames([buttonBaseCls, buttonCls]);
};
